import { render, staticRenderFns } from "./gc-field-date.vue?vue&type=template&id=4771ff4e"
import script from "./gc-field-date.vue?vue&type=script&lang=js"
export * from "./gc-field-date.vue?vue&type=script&lang=js"
import style0 from "./gc-field-date.vue?vue&type=style&index=0&id=4771ff4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports